import { ErrorBoundary as ErrorBoundaryRaw } from 'react-error-boundary';

function fallbackRender({ error }) {
	// Call resetErrorBoundary() to reset the error boundary and retry the render.

	return (
		<div role="alert"
			class="p-10 h-96">
			<article
				class=" max-w-2xl">
				<p>Something went wrong. Please screenshot this and report to us via Discord.</p>
				<small>{error.message}</small>
			</article>

		</div>
	);
}


const ErrorBoundary = ( props ) => ( <ErrorBoundaryRaw
	fallbackRender={fallbackRender}
>
	{{ ...props.children }}
</ErrorBoundaryRaw> );

export default ErrorBoundary;
